<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">DI Record Publish Date</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('DI Record Publish Date')"><label controlName="diRecordPublishDate"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Change Description</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Change Description')"><label controlName="changeDescription"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Data Supplier ID</th>
                    <th class="col-sm-6">Data Supplier Role</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Data Supplier ID')"><label controlName="dataSupplierId"></label></td>
                    <td [ngClass]="isDefault('Data Supplier Role')"><label controlName="dataSupplierRole"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Manufacturer ID</th>
                    <th class="col-sm-6">Manufacturer Name</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Manufacturer ID')"><label controlName="manufacturerId"></label></td>
                    <td [ngClass]="isDefault('Manufacturer Name')"><label controlName="manufacturerName"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Is the device associated with multiple sponsors?</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Is the device associated with multiple sponsors?')"><label controlName="multipleSponsorsIndicator"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-7">Is Primary DI same as the Registered or Filed DI?</th>
                    <th class="col-sm-5">Registered or Filed DI</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Is Primary DI same as the Registered or Filed DI?')"><label controlName="isPrimaryDiSameAsRegisteredOrFiledDi"></label></td>
                    <td [ngClass]="isDefault('Registered or Filed DI')"><label controlName="registeredOrFiledDi"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Unified Social Credit Code</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Unified Social Credit Code')"><label controlName="unifiedSocialCreditCode"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Device Registrant or Filer Name</th>
                    <th class="col-sm-6">Device Registrant or Filer Name in English</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Device Registrant or Filer Name')"><label controlName="deviceRegistrantOrFilerName"></label></td>
                    <td [ngClass]="isDefault('Device Registrant or Filer Name in English')"><label controlName="deviceRegistrantOrFilerNameInEnglish"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table formArrayName="registrationOrFilingCertificateNumbersForm" class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Registration Certificate Number or Filing Certificate Number</th>
                  </tr>
                  <ng-container *ngIf="registrationOrFilingCertificateNumbersForm.controls.length; else emptyTemplate1field">
                    <tr formGroupName="{{i}}" *ngFor="let regFil of registrationOrFilingCertificateNumbersForm.controls; let i = index">
                      <td [ngClass]="isDefault('Registration Certificate Number or Filing Certificate Number')">
                        <label controlName="regFilNumber"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td class="col-sm-6 no-left-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-7">Medical Device Information Manager Phone Number</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Medical Device Information Manager Phone Number')"><label controlName="medicalDeviceInfoManagerPhone"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

            <td class="col-sm-6 no-right-padding">
              <table class="table table-inner table-condensed ">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Medical Device Information Manager Email</th>
                  </tr>
                  <tr>
                    <td [ngClass]="isDefault('Medical Device Information Manager Email')"><label controlName="medicalDeviceInfoManagerEmail"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <feature [name]="'sk-device-license-number'">
            <tr>
              <ng-container>
                <td class="col-sm-6 no-left-padding">
                  <table class="table table-inner table-condensed ">
                    <tbody>
                      <tr>
                        <th class="col-sm-7">Device License Number</th>
                      </tr>
                      <tr>
                        <td [ngClass]="isDefault('Device License Number')">
                          <label controlName="deviceLicenseNumber"></label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </ng-container>
            </tr>
          </feature>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>

